import { createValidator, rules } from "@lchemy/model/validation";

import { Application } from "./application";

export interface ApplicationFeature {
  id: number;
  applicationId: number;
  key: string;
  name: string;
  description: string;

  application: Application;
}

// tslint:disable-next-line:no-empty-interface
export interface InsertApplicationFeatureCmd extends ApplicationFeature {}

export const insertApplicationFeatureCmdValidator = createValidator<
  InsertApplicationFeatureCmd
>({
  applicationId: [rules.required(), rules.isNumber()],
  name: [rules.required(), rules.isString(), rules.minLength(1)],
  description: [rules.isString()]
});

// tslint:disable-next-line:no-empty-interface
export interface UpdateApplicationFeatureCmd extends ApplicationFeature {}

export const updateApplicationFeatureCmdValidator = createValidator<
  UpdateApplicationFeatureCmd
>({
  id: [rules.required(), rules.isNumber()],
  name: [rules.required(), rules.isString()],
  description: [rules.required(), rules.isString()]
});
